import {
    defaultEditorStyle,
    availableStyles,
    EDITOR_BOLD,
    EDITOR_ITALIC,
    EDITOR_FONT_SIZE,
    EDITOR_FONT_FAMILY,
    EDITOR_TEXT_COLOR,
} from '../constants/chatEditorOwn';

function toggleStyle(style, property) {
    return {
        ...style,
        [property]: style[property] === availableStyles[property][0] ? availableStyles[property][1] : availableStyles[property][0]
    }
}

function applyStyle(style, rule) {
    return {
        ...style,
        ...rule
    }
}

export default function editorStateOwn(state = defaultEditorStyle, action) {
    if (action.type == EDITOR_BOLD) {
        return toggleStyle(state, 'fontWeight');
    }

    if (action.type == EDITOR_ITALIC) {
        return toggleStyle(state, 'fontStyle');
    }

    if (action.type == EDITOR_FONT_SIZE) {
        return applyStyle(state, {fontSize: action.value});
    }

    if (action.type == EDITOR_FONT_FAMILY) {
        return applyStyle(state, {fontFamily: action.value});
    }

    if (action.type == EDITOR_TEXT_COLOR) {
        return applyStyle(state, {color: action.value});
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/editorStyle.js